<template>
  <div style="position: relative;">
    <div :style="legendStyle" class="legend" v-if="legend.label && legend.label.length">
      <div class="value">{{legend.value}}</div>
      <div class="label">{{legend.label}}</div>
    </div>
    <svg :width="width" :height="height">
      <g :transform="graphTransform">
        <g :transform="'translate(' + (graphWidth / 2) + ',' + (graphHeight / 2) + ')'" >
          <path
             v-for="(d, i) in nodes"
             @click="handleSelect(d)"
             :class="selectableClass(d)"
             :d="arc(d)"
             :fill="color(i)"
             :key="i"
             @mouseover="onOver(d, i)"
             @mouseleave="onLeave" />
        </g>
      </g>
    </svg>
    <ul :style="tagListStyles">
      <li v-for="(level, i) in levels" style="display: inline-block" :style="tagStyles(level)">
        <span v-if="i !== 0 && i !== level.length" class="prev" :style="prevStyle(level)"/>
        <span class="content">{{level.label}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import * as d3 from 'd3'
import * as d3Chromatic from 'd3-scale-chromatic'
import Graph from './Graph.vue'
import margin from '../mixins/margin.js'
import selectable from '../mixins/selectable.js'

export default {
  extends: Graph,
  mixins: [
    margin,
    selectable
  ],
  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    colorScale: {
      default: () => {
        return d3.scaleSequential(d3Chromatic.interpolateRainbow)
      }
    }  
  },
  data () {
    return {
      legend: '',
      levels: []
    }
  },
  computed: {
    radius () {
      return Math.min(this.graphWidth, this.graphHeight) / 2
    },
    root () {
      return d3.hierarchy(this.data).sum(({count}) => count)
    },
    nodes() {
      return this.partition(this.root).descendants().filter((d) => d.data.level !== 0)
    },
    partition () {
      return d3.partition().size([2 * Math.PI, this.radius * this.radius])
    },
    color () {
      return this.colorScale.domain([0, this.nodes.length])
    },
    legendStyle () {
      return {
        width: this.radius / 2 + 'px',
        position: 'absolute',
        'text-align': 'center',
        top: `${(this.graphHeight / 2)}px`,
        left: `${(this.graphWidth / 2)}px`
      }
    },
    tagListStyles () {
      return {
        'position': 'absolute',
        'bottom': 0,
        'list-style': 'none',

      }
    }
  },
  methods: {
    selectData (d) {
      return d.data
    },
    selectKey (d) {
      return d.name
    },
    arc: d3.arc()
      .startAngle((d) => d.x0)
      .endAngle((d) => d.x1 )
      .innerRadius( (d) => Math.sqrt(d.y0) )
      .outerRadius( (d) => Math.sqrt(d.y1) ),
    truncateValue(d) {
      return parseFloat(d.value) === parseInt(d.value) ? d.value : d.value.toFixed(2)
    },
    onOver(d, i) {
      this.legend = {
        value: this.truncateValue(d),
        label: d.data.name
      }
      const levels = d.ancestors().map((n) => {
        let l = {
          label: n.data.name,
          color: this.color(this.nodes.indexOf(n))
        }
        if(n.parent) {
          l.parent = this.color(this.nodes.indexOf(n.parent))
        }
        return l
      }).reverse()
      levels.shift()
      this.levels.splice(0, this.levels.length, ...levels)
    },
    onLeave() {
      this.legend = {}
      this.levels.splice(0, this.levels.length)
    },
    tagStyles (level) {
      return {
        'background-color': level.color,
      }
    },
    prevStyle (level) {
      return {
        'border-top': '0.9em solid '+level.color,
        'border-bottom': '0.9em solid '+level.color,
        'border-left': '1.4em solid '+level.parent,
        'background-color': level.color
      }
    }
  }
}
</script>
<style scoped>
  li {
    position: relative;
    display: block;
    float: left;
    padding: 0.3em 0 0.3em 0;
  }
  li .prev {
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: 50%;
    margin-top: -0.9em;
    z-index: 2;
  }
  li span.content {
    margin-left: 2em;
  }
  li span.content:first-child {
    margin-left: 0.4em
  }
  li span.content:last-child {
    margin-right: 0.4em
  }

  .value {
    font-size: 1.5em;
    font-weight: 500;
  }

.selected {
    stroke: red
}
</style>



// WEBPACK FOOTER //
// node_modules/d3vue/components/SunBurst.vue